/**
 * Host-side catalog helpers for `@kaidosdragon/al-catalog`.
 *
 * Languages (MFL) studios ship in al 0.5.0 but stay hidden in my-pace until
 * that category is ready for tutors/students. Everything else is available.
 */
import { tools as allTools, getCatalogEntry as getCatalogEntryRaw, getStudio as getStudioRaw, SUBJECT_LABELS, } from '@kaidosdragon/al-catalog';
/** Subjects not yet exposed in the product UI. */
export const HIDDEN_STUDIO_SUBJECTS = new Set(['language']);
export function isStudioSubjectAvailable(subject) {
    return !HIDDEN_STUDIO_SUBJECTS.has(subject);
}
export function isStudioEntryAvailable(entry) {
    return !!entry && isStudioSubjectAvailable(entry.subject);
}
/** Catalog rows tutors/students can browse and attach (excludes Languages). */
export const tools = allTools.filter((t) => isStudioSubjectAvailable(t.subject));
export { SUBJECT_LABELS };
/** Look up by tool_id or slug. Hidden subjects resolve as unknown. */
export function getCatalogEntry(slug) {
    const entry = getCatalogEntryRaw(slug);
    if (!isStudioEntryAvailable(entry))
        return undefined;
    return entry;
}
export function getStudio(slug) {
    // Reject hidden subjects before lazy-import so Language studios never mount.
    if (!getCatalogEntry(slug)) {
        throw new Error(`Studio "${slug}" is not available in this host`);
    }
    return getStudioRaw(slug);
}
